import { render, staticRenderFns } from "./ChildrenPrivacyPolicy.vue?vue&type=template&id=4010cfa8&scoped=true"
import script from "./ChildrenPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./ChildrenPrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./ChildrenPrivacyPolicy.vue?vue&type=style&index=0&id=4010cfa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4010cfa8",
  null
  
)

export default component.exports